import { useState } from 'react';
import { IMissingInfo } from 'src/interfaces/user-mobile/missing.interface';
import { Flex, PopupButton } from 'src/styles/user-mobile/OverviewStyleMobile';
import styled from 'styled-components';
import { CENTER_PHONE } from 'src/assets/database/overviewData';
import { IS_MISSING_TEL } from 'src/consts/config.const';
import { FlexBox } from 'src/styles/OverviewStyle';
import { PopupOverlay } from './AgreePopup';

function MissingPersonPopupBox({
  info,
  i,
  total,
}: {
  info: IMissingInfo;
  i: number;
  total: number;
}) {
  const [isPopup, setIsPopup] = useState<boolean>(true);

  const handleClose = () => {
    setIsPopup(false);
  };
  return isPopup ? (
    <>
      {i === 0 && <PopupOverlay />}
      <PopupBox>
        <h1>
          {info.name}({info.age}) 실종자를 찾습니다.
        </h1>
        {info.thumbnail ? <Img src={info.thumbnail} /> : ''}

        <TextBox>
          <Flex>
            <Title>실종위치</Title>
            <Text>{info.missingLocation}</Text>
          </Flex>
          <Flex>
            <Title>실종시간</Title>
            <Text>{info.missingTime}</Text>
          </Flex>
          <Flex style={{ alignItems: 'start' }}>
            <Title>특이사항</Title>
            <TextArea>{info.content}</TextArea>
          </Flex>
        </TextBox>
        {IS_MISSING_TEL ? (
          <Flex style={{ width: '100%', marginTop: '24px', gap: '2%' }}>
            <TelButton
              onClick={() => {
                document.location.href = `tel:${CENTER_PHONE}`;
              }}
            >
              실종자 센터 연락
            </TelButton>
            <CloseButton onClick={handleClose}>
              닫기 {`(${total - i}/${total})`}
            </CloseButton>
          </Flex>
        ) : (
          <Flex
            style={{
              width: '100%',
              flexDirection: 'column',
              marginTop: '24px',
              gap: '12px',
            }}
          >
            <CautionBoard>
              실종자 발견 시, 무대 우측 종합상황실을 방문해주세요.
            </CautionBoard>
            <CloseButton style={{ width: '100%' }} onClick={handleClose}>
              닫기 {`(${total - i}/${total})`}
            </CloseButton>
          </Flex>
        )}
      </PopupBox>
    </>
  ) : (
    <></>
  );
}
export default MissingPersonPopupBox;

const PopupBox = styled.div`
  padding: 24px 16px;

  width: 376px;
  flex-shrink: 0;
  border-radius: 16px;
  background: var(--white, #fff);

  background-color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;

  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  z-index: 1000;

  h1 {
    width: 352px;
    color: var(--Font-02_black, #111);
    text-align: center;
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: 32px; /* 133.333% */

    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
`;
const Img = styled.img`
  margin-top: 12px;
  width: 180px;
  height: 240px;
  flex-shrink: 0;
  border-radius: 8px;
`;
const TextBox = styled.div`
  padding: 14px 16px;
  width: 100%;
  border-radius: 8px;
  background: #fbf7f3;
  flex-shrink: 0;
  margin-top: 12px;

  display: flex;
  flex-direction: column;
  align-items: start;
`;

const Title = styled.div`
  color: ${({ theme }) => theme.colors.fontColor};
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px; /* 150% */
`;
const Text = styled.div`
  color: #111;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 150% */
  margin-left: 6px;
`;
const CautionBoard = styled(FlexBox)`
  width: 100%;
  padding: 16px 0;
  border-radius: 6px;
  background: #fff1f1;

  color: #ec2323;
  text-align: center;
  font-size: 15px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px; /* 146.667% */
  letter-spacing: -0.375px;

  display: flex;
  justify-content: center;
  align-items: center;
`;
const TelButton = styled(PopupButton)`
  width: 64%;
`;
const CloseButton = styled(PopupButton)`
  width: 34%;
  flex-shrink: 0;

  background-color: #eee;
  color: #111;
  font-size: 17px;
  font-weight: 600;
  line-height: 24px; /* 141.176% */

  cursor: pointer;
`;

const TextArea = styled.div`
  flex-grow: 1;
  padding: 0;
  margin-left: 6px;
  color: #111;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 150% */
  overflow: hidden;
  border: 0;
  background-color: #fbf7f3;
`;
